import { ProductKind } from "./payments";

/**
 * What a shop product is (ADR 0039). A service type says what something is about, which cannot tell
 * a T-shirt from a shaker, so products have this list as well. The value is the same in every language.
 */
export enum ProductCategory {
  EBOOK = "ebook",
  VIDEO_COURSE = "video-course",
  TRAINING_PROGRAM = "training-program",
  NUTRITION_GUIDE = "nutrition-guide",
  RECIPES = "recipes",
  APPAREL = "apparel",
  EQUIPMENT = "equipment",
  SUPPLEMENTS = "supplements",
  ACCESSORIES = "accessories",
  BOOK = "book",
}

/** The categories each kind of product can be: nothing digital ships, nothing physical downloads. */
export const PRODUCT_KIND_CATEGORIES: Record<ProductKind, ProductCategory[]> = {
  [ProductKind.DIGITAL]: [
    ProductCategory.EBOOK,
    ProductCategory.VIDEO_COURSE,
    ProductCategory.TRAINING_PROGRAM,
    ProductCategory.NUTRITION_GUIDE,
    ProductCategory.RECIPES,
  ],
  [ProductKind.PHYSICAL]: [
    ProductCategory.APPAREL,
    ProductCategory.EQUIPMENT,
    ProductCategory.SUPPLEMENTS,
    ProductCategory.ACCESSORIES,
    ProductCategory.BOOK,
  ],
};
